import { useNodeId } from "@xyflow/react";
import styles from "./StepId.module.css";
import { Text } from "@zapier/design-system";

export default function StepId() {
  const id = useNodeId();

  return (
    <div className={`nodrag ${styles.stepId}`}>
      <Text color="GrayWarm10" type="SmallPrint2">
        {id}
      </Text>
    </div>
  );
}
